import IconDoorOpenSolid from '@/assets/icons/font_awesome/door-open-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function ButtonOpenPageAuth() {
  const navigate = useNavigate();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);

  /*
   * EVENTS
   */
  async function onClick() {
    await navigate(ENUM__page_type.AUTH);
  }

  return (
    <UI_PRIMITIVE__button variant="outline-on-component" onClick={onClick}>
      <IconDoorOpenSolid className="!w-5 !h-5" /> {t(i18n_page_auth.base.button.go_to_auth_page)}
    </UI_PRIMITIVE__button>
  );
}
